import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "fcon_add_trigger"
};
var _hoisted_2 = {
  "class": "fcon_provider_selectors"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["title", "src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[6] || (_cache[6] = _createElementVNode("h3", null, "Select Integration", -1 /* HOISTED */)), _createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.all_triggers, function (provider, providerKey) {
    return _openBlock(), _createElementBlock("li", {
      "class": _normalizeClass({
        fcon_active_trigger: providerKey == $data.trigger.trigger_provider
      }),
      onClick: function onClick($event) {
        return $options.changeTriggerProvider(providerKey);
      }
    }, [_createElementVNode("img", {
      title: provider.title,
      src: provider.logo
    }, null, 8 /* PROPS */, _hoisted_4)], 10 /* CLASS, PROPS */, _hoisted_3);
  }), 256 /* UNKEYED_FRAGMENT */))]), $options.selectedProvider && $options.selectedProvider.require_integration_selector ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_cache[4] || (_cache[4] = _createElementVNode("h4", null, "Select Integration Account", -1 /* HOISTED */)), _createVNode(_component_el_select, {
    modelValue: $data.trigger.integration_id,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.trigger.integration_id = $event;
    }),
    placeholder: "Select Integration Account"
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.selectedRemoteIntegrations, function (integration) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: integration.id,
          value: integration.id,
          label: integration.title
        }, null, 8 /* PROPS */, ["value", "label"]);
      }), 128 /* KEYED_FRAGMENT */))];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]), _createVNode(_component_el_button, {
    style: {
      "margin-top": "20px"
    },
    disabled: !$data.trigger.integration_id,
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.triggerSuccess();
    }),
    type: "primary"
  }, {
    "default": _withCtx(function () {
      return _cache[3] || (_cache[3] = [_createTextVNode("Continue")]);
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled"])], 64 /* STABLE_FRAGMENT */)) : this.trigger.trigger_provider ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    style: {
      "margin-top": "20px"
    },
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.triggerSuccess();
    }),
    type: "primary"
  }, {
    "default": _withCtx(function () {
      return _cache[5] || (_cache[5] = [_createTextVNode("Continue")]);
    }),
    _: 1 /* STABLE */
  })) : _createCommentVNode("v-if", true)]);
}